import { useState, useEffect } from "react";
import Header from "../layout/header";
import { Loader } from "react-overlay-loader";
import { axiosInstance } from "../config/https";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { Card } from "react-bootstrap";

export default function EditUser() {
  const [loader, setLoader] = useState(false);
  const [, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  const [, setMessage] = useState([]);
  const [email, setEmail] = useState("");
  const [cellNo, setCellNo] = useState("");
  const [addres, setAddres] = useState("");
  const [fName, setFName] = useState("");
  const [lName, setLName] = useState("");

  const handleContactus = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("first_name", fName);
    formData.append("last_name", lName);
    formData.append("email", email);
    formData.append("phone", cellNo);
    formData.append("address", addres);

    try {
      const response = await axiosInstance.post(`/update/user/${id}`, formData);

      console.log(response, "Success");
      if (response.data.status === true) {
        toast.success("Details submit successful");
        setMessage(response?.data?.message);
        setLName("");
        setFName("");
        setEmail("");
        setCellNo("");
        setAddres("");
        setErrors({});
        navigate("/user")
      } else {
        const apiErrors = response?.data?.data;
        if (apiErrors) {
          setErrors(apiErrors);
        } else {
          toast.error("Form Submission Failed");
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    GetUser();
  }, []);

  // GET users
  const GetUser = () => {
    setLoader(true);
    axiosInstance.get(`/edit/user/${id}`).then((response) => {
      setLoader(false);
      console.log("res", response);
      const { first_name, last_name, email, phone, address } = response?.data?.data;
      setFName(first_name);
      setLName(last_name);
      setEmail(email);
      setCellNo(phone);
      setAddres(address);

      if (response?.data?.status) {
        setData(response.data.data);
      } else {
        toast.warning(response?.data?.message);
      }
    });
  };

  return (
    <div>
      {loader === true ? <Loader fullPage loading /> : null}

      <Header />
      <div className="app-content content">
        <div className="content-wrapper">
          <div className="content-header row">
            <div className="content-header-left col-md-12 mb-2 breadcrumb-new">
              <h3 className="content-header-title mb-0 d-inline-block">
                Update User
              </h3>
            </div>
          </div>
          <div className="content-body d-flex justify-content-center">
            <Card className="col-md-8">
              <Card.Body>
                <form id="userForm" onSubmit={handleContactus}>
                  <div class="form-group">
                    <label for="firstName">First Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      value={fName}
                      onChange={(e) => setFName(e.target.value)}
                      required
                    />
                    {errors && (
                      <span className="error">{errors.first_name}</span>
                    )}
                  </div>
                  <div class="form-group">
                    <label for="lastName">Last Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      value={lName}
                      onChange={(e) => setLName(e.target.value)}
                      required
                    />
                    {errors && (
                      <span className="error">{errors.last_name}</span>
                    )}
                  </div>
                  <div class="form-group">
                    <label for="email">Email</label>
                    <input
                      className="form-control"
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    {errors && <span className="error">{errors.email}</span>}
                  </div>
                  <div class="form-group">
                    <label for="phone">Phone</label>
                    <input
                      className="form-control"
                      type="text"
                      name="phone"
                      value={cellNo}
                      onChange={(e) => setCellNo(e.target.value)}
                      required
                    />
                    {errors && errors.phone && (
                      <span className="error">{errors.phone[0]}</span>
                    )}
                  </div>
                  <div class="form-group">
                    <label for="address">Address</label>
                    <input
                      className="form-control"
                      type="text"
                      name="address"
                      value={addres}
                      onChange={(e) => setAddres(e.target.value)}
                      required
                    />
                    {errors && <span className="error">{errors.address}</span>}
                  </div>
                  <div>
                  <button
                    type="submit"
                    class="btn btn d-flex justify-content-center"
                    style={{ backgroundColor: "#1E9FF2", textAlign: '-webkit-center' }}
                  >
                    Update
                  </button>
                  </div>
                </form>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
